import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';
// @ts-expect-error
import type {LocationShape} from 'react-router-dom';

import {EmailSequenceIcon} from '../icon/email-sequence-icon';
import {Link} from '../link/link';
import {Truncated} from '../truncated/truncated';

import styles from './email-sequence-name.module.css';

type Props = {
    sequenceName: string;
    messageCount: number;
    htmlUrlPath?: string | LocationShape;
};

export function EmailSequenceName(props: Props) {
    const {htmlUrlPath, sequenceName, messageCount} = props;

    if (!messageCount) {
        return <Truncated title={sequenceName}>{sequenceName}</Truncated>;
    }

    const contents = (
        <div className={styles.contents}>
            <EmailSequenceIcon messageCount={messageCount} size={15} />
            <Truncated title={sequenceName}>{sequenceName}</Truncated>
        </div>
    );

    if (!htmlUrlPath) return contents;

    return (
        // @ts-expect-error
        <Link as={RouterLink} to={htmlUrlPath}>
            {contents}
        </Link>
    );
}
